/**
 * ContactPicker — §35: the CONTACT filter's search-and-pick control on the
 * EntityPicker core, over GET /v1/sales/contacts?search= (the server's own
 * ILIKE across full name, email and company, live since §8). A FILTER
 * value: the id is what travels; the text is what was picked. Typing after
 * a pick clears the id — the filter names ONE contact, and changed text is
 * no longer that contact. contactId '' = no filter, whatever the text says.
 */
import { fetchContacts } from '../../api'
import type { SalesContact } from '../../types'
import { EntityPicker } from './EntityPicker'

export interface ContactPick {
  /** '' = no filter. */
  contactId: string
  text: string
}

export function ContactPicker({ value, onChange, className, id, placeholder }: {
  value: ContactPick
  onChange: (next: ContactPick) => void
  className: string
  id?: string
  placeholder?: string
}) {
  return (
    <EntityPicker<SalesContact>
      id={id} className={className} placeholder={placeholder ?? 'Search contacts…'}
      text={value.text}
      onTextChange={t => onChange({ contactId: '', text: t })}
      search={q => fetchContacts({ search: q, limit: 8 })}
      rowKey={c => c.id}
      selectedKey={value.contactId || undefined}
      renderRow={c => (
        <>
          <span className="text-13 font-medium text-ink-primary truncate">{c.name}</span>
          {c.company !== '' && <span className="text-11 text-ink-muted whitespace-nowrap truncate">{c.company}</span>}
        </>
      )}
      onPick={c => onChange({ contactId: c.id, text: c.name })}
      emptyPrompt="Type to search contacts"
      noMatch="No matching contact"
    />
  )
}
